import { Injectable } from '@angular/core';
import { BaseService } from '@app/core/services/base/base.service';
import { filter, tap } from 'rxjs/operators';
import { ServerEventService } from '../server-event.service';
import { DrEvent } from '@app/shared/models/server-event.model';
import { DistributionJob } from '@app/shared/models/distribution-doc-models';

export enum DistributionWebSocketMessages {
    SUCCESS = 'success',
    ERROR = 'error'
}

export interface DistributionEventData extends DrEvent<DistributionJob, DistributionWebSocketMessages> {}

@Injectable({
    providedIn: 'root'
})
export class DistributionWebSocketService extends BaseService {
    public static WebSocketEvents = {
        PREPARED: 'distribution.job.prepared',
        SENT: 'distribution.job.sent',
        SIGNED: 'distribution.job.signed'
    };

    private readonly msgPrefix = 'DistributionWebSocketService';

    get distributionSockets() {
        return this._serverEventService.events.pipe(
            filter((event) => [
                DistributionWebSocketService.WebSocketEvents.PREPARED,
                DistributionWebSocketService.WebSocketEvents.SENT,
                DistributionWebSocketService.WebSocketEvents.SIGNED
            ].includes(event.event)),
            
            tap((event) =>
              console.log(`${this.msgPrefix} - processing event: ${event.event}`)
            )
        );
    }

    constructor(private _serverEventService: ServerEventService<DistributionJob>) {
        super();
    }
}
